module.exports = __webpack_public_path__ + "img/隐私政策content.0ca9219e.png";